<div class="row">
  <div id="price-list-title" class="col-md-12 price-list-title">מחירון</div>
  <div class="price-list-wrapper">
    <div
      class="arrow-price-list-left"
      *ngIf="displayPriceListLeft"
      (click)="scrollPriceListLeft()"
    >
      <fa-icon [icon]="['fas', 'arrow-circle-left']"></fa-icon>
    </div>
    <div
      class="arrow-price-list-right"
      *ngIf="displayPriceListRight"
      (click)="scrollPriceListRight()"
    >
      <fa-icon [icon]="['fas', 'arrow-circle-right']"></fa-icon>
    </div>
    <div class="price-list col-md-12" (scroll)="pricelistScroll($event)">
      <table class="table">
        <thead>
          <tr>
            <th scope="row"></th>
            <th
              scope="col"
              class="price-list-col-title"
              [ngClass]="{
                'price-list-active': prodindex == pUiService.currentOptionIndex
              }"
              *ngFor="let item of pUiService.productView.ProductOptionItems; let prodindex = index"
            >
              {{ item.ProductOptionItem.OptionTitle }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">מחיר בסיסי</th>
            <td
              scope="row"
              class="price-list-col-detail"
              [ngClass]="{
                'price-list-active': prodindex == pUiService.currentOptionIndex
              }"
              *ngFor="let item of pUiService.productView.ProductOptionItems; let prodindex = index"
            >
              {{ item.ProductOptionItem.BaseOptionPrice }} ₪
            </td>
          </tr>
          <tr>
            <th scope="row">תוספת שרטוט לפי מטר</th>
            <td
              scope="row"
              class="price-list-col-detail"
              [ngClass]="{
                'price-list-active': prodindex == pUiService.currentOptionIndex
              }"
              *ngFor="let item of pUiService.productView.ProductOptionItems; let prodindex = index"
            >
              <div *ngIf="filterFormatPrices(item.ExistFileFormatItems)">
                {{ filterFormatPrices(item.ExistFileFormatItems) }}
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">תוספת לקבלת תוכנית DWG</th>
            <td
              scope="row"
              class="price-list-col-detail"
              [ngClass]="{
                'price-list-active': prodindex == pUiService.currentOptionIndex
              }"
              *ngFor="let item of pUiService.productView.ProductOptionItems; let prodindex = index"
            >
              {{ item.ProductOptionItem.PriceForDWGFile }} ₪
            </td>
          </tr>
          <tr>
            <th scope="row">תיקון אקסטרא</th>
            <td
              scope="row"
              class="price-list-col-detail"
              [ngClass]="{
                'price-list-active': prodindex == pUiService.currentOptionIndex
              }"
              *ngFor="let item of pUiService.productView.ProductOptionItems; let prodindex = index"
            >
              <div
                *ngFor="
                  let fixPrice of item.FixesPricesItems;
                  let fixPriceIndex = index
                "
              >
                <span *ngIf="fixPriceIndex == 0 && fixPrice.Price > 0"
                  >{{ fixPrice.Price }} ₪</span
                >
                <span
                  *ngIf="
                    fixPriceIndex == 1 &&
                    item.FixesPricesItems[0].Price == 0 &&
                    fixPrice.Price > 0
                  "
                  >{{ fixPrice.Price }} ₪</span
                >
              </div>
              <div
                *ngIf="
                  item.FixesPricesItems.length == 0 ||
                  (item.FixesPricesItems.length == 1 &&
                    item.FixesPricesItems[0].Price == 0)
                "
              >
                ללא אפשרות
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <app-dynamic-options-pricelist
       [currentOptionIndex]="pUiService.currentOptionIndex" 
       [ProductOptionItems]="pUiService.productView.ProductOptionItems"
       ></app-dynamic-options-pricelist>
    </div>
  </div>

  <div class="col-md-12 price-list-tax-comment">המחירים כוללים מע"מ</div>
</div>
